import { makeStyles } from '@mui/styles';
import TableComponent from 'components/Table';
import React, { FC } from 'react';
import { NewUserType } from 'types/new-user';

import { ColumnsType } from '../services';

// Explicit bounded scroll region: the table owns horizontal overflow, never the page.
const useStyles = makeStyles({ scrollRegion: { overflowX: 'auto' } });

type ListProps = {
  parties: NewUserType[];
  columns: ColumnsType;
  handleEditNav: (id: string) => void;
};

const List: FC<ListProps> = ({ parties, columns, handleEditNav }) => {
  const classes = useStyles();

  return (
    <div className={classes.scrollRegion}>
      <TableComponent
        pointer
        disabledBorderLeft
        columns={columns}
        dataSet={parties || []}
        onClickItem={(party: NewUserType) => {
          handleEditNav(party._id);
        }}
      />
    </div>
  );
};

export default List;
